const Dates = (moment) => {
  const today = moment().format("YYYY-MM-DD");

  const currMonthStart = moment().format("YYYY-MM-01");
  const currMonthEnd = moment().format("YYYY-MM-") + moment().daysInMonth();

  const lastMonth = moment().subtract(1, "months");
  const lastMonthStart = lastMonth.format("YYYY-MM-01");
  const lastMonthEnd = lastMonth.format("YYYY-MM-") + moment(lastMonth).daysInMonth();

  const currQuarter = moment().quarter();
  const currQuarterStart = moment()
    .quarter(currQuarter)
    .startOf("quarter")
    .format("YYYY-MM-DD");
  const currQuarterEnd = moment()
    .quarter(currQuarter)
    .endOf("quarter")
    .format("YYYY-MM-DD");

  const lastQuarter = currQuarter - 1;
  const lastQuarterStart = moment()
    .quarter(lastQuarter)
    .startOf("quarter")
    .format("YYYY-MM-DD");
  const lastQuarterEnd = moment()
    .quarter(lastQuarter)
    .endOf("quarter")
    .format("YYYY-MM-DD");

  const currYear = moment().format('YYYY') - 0;
  const currYearStart = moment()
    .startOf("year")
    .format("YYYY-MM-DD");
  const currYearEnd = moment()
    .endOf("year")
    .format("YYYY-MM-DD");

  const lastYear = currYear - 1;
  const lastYearRaw = moment().subtract(1, "years");
  const lastYearStart = lastYearRaw.startOf("year").format("YYYY-MM-DD");
  const lastYearEnd = lastYearRaw.endOf("year").format("YYYY-MM-DD");

  return {
    today,
    currMonthStart,
    currMonthEnd,
    lastMonthStart,
    lastMonthEnd,
    currQuarterStart,
    currQuarterEnd,
    lastQuarterStart,
    lastQuarterEnd,
    currYear,
    currYearStart,
    currYearEnd,
    lastYear,
    lastYearStart,
    lastYearEnd
  };
};

export default Dates;